import { ArrowLeft, WarningCircle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-1 text-zinc-500 hover:text-white text-xs font-mono mb-6">
          <ArrowLeft size={14} /> Back
        </Link>
        <h1 className="text-3xl font-black mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Disclaimer</h1>

        <div className="border-2 border-[#E12B00] bg-[#E12B00]/10 p-6 mb-6">
          <div className="flex items-start gap-3">
            <WarningCircle weight="fill" size={24} className="text-[#E12B00] flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-[#E12B00] font-bold text-lg mb-2">Important Notice</h2>
              <p className="text-white text-sm leading-relaxed">
                <strong>The win chance percentages, odds, and predictions displayed on Racing Form Guide are calculated by RAW Company Tech's proprietary algorithm.</strong> They are <strong>NOT</strong> official bookmaker odds. They do not represent the odds offered by any licensed bookmaker or betting exchange.
              </p>
            </div>
          </div>
        </div>

        <div className="prose prose-invert prose-sm max-w-none space-y-4 text-zinc-300">
          <h2 className="text-white text-lg font-bold mt-6">Our Odds Are Not Official</h2>
          <p>Racing Form Guide uses a proprietary AI algorithm that analyses publicly available data including horse form, official ratings (OFR, RPR), trainer statistics, jockey career win rates, owner win rates, and aggregated bookmaker market data to calculate a "Win Chance %" for each runner. These percentages are our own calculations and do not constitute official odds from any bookmaker.</p>

          <h2 className="text-white text-lg font-bold mt-6">For Entertainment & Information Only</h2>
          <p>All information, data, statistics, predictions, and "Daily Tips" provided by Racing Form Guide are for entertainment and informational purposes only. They should not be relied upon as the sole basis for any betting or financial decisions.</p>

          <h2 className="text-white text-lg font-bold mt-6">No Guarantee of Accuracy</h2>
          <p>While we strive to provide accurate and up-to-date information, we make no warranties or representations regarding the accuracy, completeness, or reliability of any data or predictions. Horse racing outcomes are inherently unpredictable.</p>

          <h2 className="text-white text-lg font-bold mt-6">Gamble Responsibly</h2>
          <p>If you choose to bet on horse racing, please do so responsibly. Never bet more than you can afford to lose. If you believe you may have a gambling problem, please contact:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>GamCare:</strong> 0808 8020 133 | www.gamcare.org.uk</li>
            <li><strong>BeGambleAware:</strong> 0808 8020 133 | www.begambleaware.org</li>
            <li><strong>Gambling Commission:</strong> www.gamblingcommission.gov.uk</li>
          </ul>

          <h2 className="text-white text-lg font-bold mt-6">Third-Party Data</h2>
          <p>Race data is sourced from The Racing API and other third-party providers. Bookmaker odds displayed are aggregated from publicly available sources and may not reflect current real-time prices. Always check odds directly with your bookmaker before placing any bet.</p>

          <h2 className="text-white text-lg font-bold mt-6">Not a Licensed Betting Operator</h2>
          <p>RAW COMPANY TECH LIMITED is not a licensed betting operator, bookmaker, or gambling company. We provide data analysis tools only. Any betting functionality within the app operates with virtual funds for demonstration purposes.</p>

          <h2 className="text-white text-lg font-bold mt-6">Limitation of Liability</h2>
          <p>RAW COMPANY TECH LIMITED accepts no liability for any losses, damages, or costs arising from the use of information provided by Racing Form Guide, including but not limited to any losses incurred through betting activities.</p>

          <h2 className="text-white text-lg font-bold mt-6">18+ Only</h2>
          <p>This service is for users aged 18 and over only. By using Racing Form Guide, you confirm that you are at least 18 years of age.</p>
        </div>
        <div className="border-t border-zinc-800 mt-8 pt-4 text-[10px] text-zinc-600 text-center font-mono">
          &copy; {new Date().getFullYear()} RAW COMPANY TECH LIMITED &middot; Company No. 17349121 &middot; England & Wales
        </div>
      </div>
    </div>
  );
}
